import {Route, Switch, useLocation} from 'react-router-dom';
import Error from './pages/404';
import GlobalStyle from "./styles/globalStyle";
import {ImageReveal} from "./components/animations/ImageReveal";
import {Parallax, ParallaxImg} from "./components/animations/Parallax";
import {gsap} from "gsap";
import {ScrollSmoother} from "gsap/ScrollSmoother";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import 'react-toastify/dist/ReactToastify.css';
import 'simplebar-react/dist/simplebar.min.css';
import {SplitText} from "gsap/SplitText";
import {useDispatch, useSelector} from "react-redux";
import {apiEndPoints} from "./api/network/apiEndPoints";
import {fetchFooter} from "./api/redux/footer";

// page imports
import About from './pages/about';
import Components from './pages/components';
import Home from './pages/home';
import Equipment from './pages/equipment';
import Project from './pages/project';
import ProjectDetail from './pages/project/single';
import Contact from './pages/contact';
import {SplitUp} from "./components/animations/TextAnimation";
import {useEffect, useLayoutEffect, useRef, useState} from "react";
import PageTransition from "./components/animations/PageTransition";
import Footer from "./components/Footer";
import Menu from "./components/Menu";
import {ToastContainer} from "react-toastify";

function App() {

    const location = useLocation();
    gsap.registerPlugin(ScrollTrigger, ScrollSmoother);


    const [offset, setOffset] = useState(0)
    useEffect(() => {
        setOffset(Number(localStorage.getItem('containeroffset')))
    }, [])


    // smooth scroll init
    const el = useRef();
    useLayoutEffect(() => {
        let smoother = ScrollSmoother.create({
            smooth: 2, // how long (in seconds) it takes to "catch up" to the native scroll position
            // effects: true // looks for data-speed and data-lag attributes on elements
            speed: 2
        });
        return () => {
            smoother.kill();
        };
    }, []);

    // route change scroll top & page class
    useEffect(() => {
        if (location.pathname === '/') {
            document.body.classList.add('in-home-page')
        } else {
            document.body.classList.remove('in-home-page')
        }

        // window.scroll(0, 0)
    }, [location.pathname])


    // animation functions
    ImageReveal()
    Parallax()
    ParallaxImg()
    SplitUp()


    // page transition
    PageTransition()


    // smooth scroll
    let smoother;
    useLayoutEffect(() => {
        smoother = ScrollSmoother.create({
            smooth: 2, // how long (in seconds) it takes to "catch up" to the native scroll position
            effects: true, // looks for data-speed and data-lag attributes on elements
            // speed: 2,
        });
        ScrollTrigger.refresh();

        if (location.hash) {
            setTimeout(() => {
                smoother.scrollTo(location.hash, 3)
            }, 800)
        }
        if(!location.hash){
            window.scroll(0, 0)
        }
    }, [location, location.pathname, location.hash])


    //To get the first & second slug
    const pathSegments = location.pathname.split("/");
    const secondSegment = pathSegments[2];

    //Handle the sticky bar for project-page and landowner-page

    const [isProjectPage, setIsProjectPage] = useState(false);

    useEffect(() => {
        if(secondSegment) {
            setIsProjectPage(true)
        }
        else setIsProjectPage(false)

    }, [location?.pathname]);


    //canonical

    useEffect(() => {
        // Get the current URL from the router's full path
        const currentUrl = window.location.origin + location.pathname + location.search;

        // Set the canonical link dynamically
        const link = document.createElement('link');
        link.rel = 'canonical';
        link.href = currentUrl;
        document.head.appendChild(link);

        // Clean up the link when the component unmounts
        return () => {
            document.head.removeChild(link);
        };
    }, [location.pathname, location.search]);


    const dispatch = useDispatch()

    // api call
    useEffect(() => {
        let api_url = apiEndPoints.FOOTER
        dispatch(fetchFooter([api_url]))
    }, [])

    let getPost = useSelector(state => state.footer)


    return (
        <>
            <ToastContainer position="top-right" autoClose={4000} closeOnClick hideProgressBar={true}/>
            <GlobalStyle/>
            <Menu isProjectPage={isProjectPage}/>
            {/*page transition */}
            <div className="page-loader">
                <img src="/images/static/logo-white.svg" alt=""/>
            </div>
            <div className="App" ref={el} id="smooth-wrapper">
                <div id="smooth-content">
                    <Switch location={location} key={'location.pathname'}>
                        <Route exact path="/" component={Home}/>
                        <Route exact path="/components" component={Components}/>
                        <Route exact path="/about" component={About} smoother={smoother}/>
                        <Route exact path={`/projects`} component={Project}/>
                        <Route exact path={`/project/:slug`} component={ProjectDetail}/>
                        <Route exact path={`/contact`} component={Contact}/>
                        <Route exact path={`/equipments`} component={Equipment}/>
                        <Route component={Error}/>
                    </Switch>
                    <Footer data={getPost?.posts?.footer_data}/>
                </div>
            </div>
        </>


    );
}

export default App;
